import {NavigationEnd, Router, RouterEvent} from '@angular/router';
import {Injectable} from '@angular/core';
import {filter} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RouterExtendedService {
  private previousUrl: string = undefined;
  private currentUrl: string = undefined;

  constructor(private router: Router) {
    this.currentUrl = this.router.url;

    router.events
      .pipe(filter((e: NavigationEnd): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e: RouterEvent) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = e.url;
      });
  }

  public getPreviousUrl() {
    return this.previousUrl;
  }
}
